import PropTypes from 'prop-types';
import EditUserDialog from './EditUserDialog';
import NewUserDialog from './NewUserDialog';

// ----------------------------------------------------------------------

export default function UserDialog(props) {

  return props.id ? <EditUserDialog {...props} /> : <NewUserDialog {...props} />;
}

UserDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  id: PropTypes.number
};
